import { render, staticRenderFns } from "./QuantidadeAulasPorPeriodoModal.vue?vue&type=template&id=75946644&scoped=true"
import script from "./QuantidadeAulasPorPeriodoModal.vue?vue&type=script&lang=js"
export * from "./QuantidadeAulasPorPeriodoModal.vue?vue&type=script&lang=js"
import style0 from "./QuantidadeAulasPorPeriodoModal.vue?vue&type=style&index=0&id=75946644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75946644",
  null
  
)

export default component.exports